import Typography from 'components/atoms/Typography';
import { ActionType } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/action';
import { HubAuthoringContext, HubAuthoringDispatchContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { useContext } from 'react';
import { CompactPicker } from 'react-color';

const HubHeaderColorSettings = () => {
  const {
    hubUpsertParams: { titleColor, descriptionColor, backgroundColor },
  } = useContext(HubAuthoringContext);
  const dispatch = useContext(HubAuthoringDispatchContext);

  return (
    <div>
      <Typography className="text-sm text-glooCharcoal font-semibold py-2" variant="base">
        Title Text Color
      </Typography>
      <CompactPicker
        color={titleColor || '#000'}
        onChange={(color) => {
          dispatch({
            type: ActionType.setTitleColor,
            payload: color.hex,
          });
        }}
      />
      <Typography className="text-sm text-glooCharcoal font-semibold py-2" variant="base">
        Long Description Text Color
      </Typography>
      <CompactPicker
        color={descriptionColor || '#000'}
        onChange={(color) => {
          dispatch({
            type: ActionType.setDescriptionColor,
            payload: color.hex,
          });
        }}
      />
      <Typography className="text-sm text-glooCharcoal font-semibold py-2" variant="base">
        Background Color
      </Typography>
      <CompactPicker
        color={backgroundColor || '#FFF'}
        onChange={(color) => {
          dispatch({
            type: ActionType.setBackgroundColor,
            payload: color.hex,
          });
        }}
      />
    </div>
  );
};

export default HubHeaderColorSettings;
